import useClientMutation from '../../common/useClientMutation';
import { USER_LOGOUT } from '../../consts';

import type { LogoutInput, LogoutOutput } from '@haaretz/s-data-structure-types';

type InitProps =
  | {
      onSuccess?: (data: LogoutOutput) => void;
      onError?: (data: Error) => void;
    }
  | undefined;

export default function useLogout(props: InitProps) {
  return useClientMutation<LogoutOutput, LogoutInput>({
    cacheKey: 'userLogout',
    url: USER_LOGOUT,
    fetchOptions: {
      method: 'POST',
      headers: { accept: 'application/json', 'content-Type': 'application/x-www-form-urlencoded' },
    },
    clientOptions: {
      useErrorBoundary: false,
      retry: false,
      cacheTime: 0,
      onSuccess: props?.onSuccess,
      onError: props?.onError,
    },
    transformResponse: result => {
      return {
        ...result,
        success: result.success === true || result.success === 'true',
        ...(Array.isArray(result.message)
          ? { message: undefined, messages: result.message }
          : typeof result.message === 'string'
            ? { message: undefined, messages: [result.message] }
            : {}),
      };
    },
  });
}
